import React from 'react';

import './assets/scss/themes.scss';
import Route from './routes';
import SessionTimeout from './components/Session/SessionTimeout';

function App() {
  return (
    <>
      <SessionTimeout />
      <Route />
    </>
  );
}

export default App;
